import React from 'react';
import { useStyles } from '../../../pages/styles';

const MainDiv: React.FC = (props) => {
  const globalStyle = useStyles();

  return <div className={globalStyle.main}>{props.children}</div>;
};

export default MainDiv;
